import { render } from "./DisclaimerDialog.vue?vue&type=template&id=ee2ed0d4&scoped=true"
import script from "./DisclaimerDialog.vue?vue&type=script&lang=js"
export * from "./DisclaimerDialog.vue?vue&type=script&lang=js"

import "./DisclaimerDialog.vue?vue&type=style&index=0&id=ee2ed0d4&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee2ed0d4"]])

export default __exports__